import type { VacancyId } from './vacancies';

export const DEFAULT_MIRROR_ID = 'default';

export interface MirrorInfo {
  id: string;
  label: string;
  vacancies: VacancyId[];   // порядок значим — это порядок карточек на /vacancy
}

/** Фолбэк на случай, когда бэк не прислал зеркало (старый бэк / откат). */
export const FALLBACK_MIRRORS: Record<string, MirrorInfo> = {
  default: {
    id: 'default',
    label: 'Основной',
    vacancies: ['hr-manager', 'chat-operator'],
  },
  qs: {
    id: 'qs',
    label: 'Качество и соцсети',
    vacancies: ['quality-manager', 'smm-manager'],
  },
  om: {
    id: 'om',
    label: 'Онлайн-менеджер',
    vacancies: ['online-manager'],
  },
};

export function fallbackMirror(id: string): MirrorInfo {
  return FALLBACK_MIRRORS[id] ?? FALLBACK_MIRRORS[DEFAULT_MIRROR_ID];
}
